import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { makeStyles } from '@material-ui/core';

interface IProps {
  children?: any;
  modalTitle: string;
  modalContent?: any;
  open: boolean;
}

 const useStyles = makeStyles(theme => ({
   dialogTitle: {
     '& > h2': {
       fontSize: '1.625em',
       textTransform: 'initial',
       color: theme.palette.grey[600],
       fontWeight: 600,
     }
   },
   content: {
     padding: '0 24px 24px'
   }
 }))

const ModalCustom = ({ children, modalTitle, modalContent, open}: IProps) => {
    const classes = useStyles();

    return (
      <Dialog open={open} scroll="paper" className="">
        <DialogTitle className={classes.dialogTitle}>{modalTitle}</DialogTitle>
        <DialogContent className={classes.content}>
          {!modalContent && <div>Carregando</div>}
          {modalContent && typeof modalContent == 'object' && <div>{modalContent}</div>}
          {modalContent && typeof modalContent == 'string' && (
            <DialogContentText dangerouslySetInnerHTML={{ __html: modalContent }} />
          )}
        </DialogContent>
        {!!children && <DialogActions>{children}</DialogActions>}
      </Dialog>
    );
}

export default ModalCustom;
